import React from 'react'

import { sanitizeAndProcessHtml } from '@/_lib/dom-purify.utils'

export interface HeaderData {
	text: string
	level: number
}

export interface BEditorJsHeaderProps {
	data: HeaderData
	style?: React.CSSProperties
}

export const BEditorJsHeader: React.FC<BEditorJsHeaderProps> = ({ data, style }) => {
	const { text, level } = data

	const sanitizedLevel = Math.min(Math.max(level, 1), 6)

	const renderHeading = () => {
		if (!text?.trim()) {
			return null
		}

		const headingProps = {
			className: `editorjs-renderer_header editorjs-renderer_header_level_${sanitizedLevel}`,
			style,
			suppressHydrationWarning: true,
			dangerouslySetInnerHTML: { __html: sanitizeAndProcessHtml(text) }
		}

		switch (sanitizedLevel) {
			case 1:
				return <h1 {...headingProps} />
			case 2:
				return <h2 {...headingProps} />
			case 3:
				return <h3 {...headingProps} />
			case 4:
				return <h4 {...headingProps} />
			case 5:
				return <h5 {...headingProps} />
			case 6:
				return <h6 {...headingProps} />
			default:
				return <h2 {...headingProps} />
		}
	}

	return <div className='editorjs-renderer_block'>{renderHeading()}</div>
}

export default BEditorJsHeader
